/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditProfileStatus {
    getFixupPrototypeFunction() { return RequestAuditProfileStatus.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditProfileStatus>): RequestAuditProfileStatus {
        let obj = Object.assign(new RequestAuditProfileStatus(), model);
        RequestAuditProfileStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditProfileStatus>): RequestAuditProfileStatus {
        if (!model) return null;
        return RequestAuditProfileStatus.newInstance(<RequestAuditProfileStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditProfileStatus) {
        if (!obj) return;

        models.RequestAuditProfileStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditProfileStatus): boolean {
        Object.setPrototypeOf(obj, RequestAuditProfileStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.activations === undefined) {
            this.activations = 0;
        }
        if (this.execution_time_threshold === undefined) {
            this.execution_time_threshold = 0;
        }
    }

    /**
     * Target executor
     */
    executor: models.BackgroundJobExecutor;

    /**
     * Target endpoint
     */
    endpoint: string;

    /**
     * Target resource path
     */
    path: string;

    /**
     * Number of activations.
     */
    activations: number;

    /**
     * Only log profiles that take longer than this time.
     */
    execution_time_threshold: number;

}
